import React, { useState, useEffect } from "react";
import { loadSection } from "../../services/contentSource";
import clientsFallback from "../../data/home/clients.json";

interface ClientSliderProps {
  label?: string;
}

const ClientSlider: React.FC<ClientSliderProps> = ({
  label = "COLLABORATING WITH FORWARD-THINKING BRANDS & HIGH-GROWTH TEAMS",
}) => {
  const [data, setData] = useState<any>(clientsFallback);

  useEffect(() => {
    loadSection("clients", clientsFallback as any).then(({ data: main }) => {
      if (main) setData(main);
    });
  }, []);

  const rawClients: string[] = data?.clients || clientsFallback.clients || [];
  // Ensure we have enough logos to create a seamless infinite marquee
  const displayClients =
    rawClients.length > 0 ? [...rawClients, ...rawClients] : [];

  if (displayClients.length === 0) return null;

  return (
    <section className="mx-client-marquee-wrap" aria-label="Client Brands">
      {label && (
        <div className="container mx-container">
          <div className="mx-client-marquee-header">
            <p className="mx-client-marquee-title">{label}</p>
          </div>
        </div>
      )}

      <div className="mx-client-marquee-container">
        <div className="mx-client-marquee-track">
          {displayClients.map((clientSrc: string, index: number) => (
            <div className="mx-client-logo-card" key={index}>
              <img
                src={clientSrc}
                alt={`Partner brand logo ${index + 1}`}
                className="mx-client-logo-img"
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientSlider;
